import React, { useState } from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { Table, Space, Input, Tag } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { MissingTranslationsButton } from '../../components/MissingTranslationsButton';

interface SystemMessageDto {
  id: string;
  key: string;
  namespace: string;
  description?: string | null;
  defaultText: string;
  translations?: Record<string, { text?: string }> | null;
  paramsSchema?: string[] | null;
  updatedAt: string;
}

export const SystemMessageList: React.FC = () => {
  const [searchText, setSearchText] = useState('');

  const { tableProps } = useTable<SystemMessageDto>({
    resource: 'system-messages',
    filters: {
      permanent: [{ field: 'search', operator: 'contains', value: searchText }],
    },
    pagination: { current: 1, pageSize: 20 },
    queryOptions: { keepPreviousData: true },
  });

  return (
    <List
      resource="system-messages"
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <MissingTranslationsButton
            endpoint="admin/system-messages/missing-translations"
            resourceLabel="System Messages"
          />
        </>
      )}
    >
      <div style={{ marginBottom: 16 }}>
        <Input.Search
          prefix={<SearchOutlined />}
          placeholder="Search by key or text..."
          defaultValue={searchText}
          onSearch={(value) => setSearchText(value)}
          allowClear
          style={{ width: 360 }}
        />
      </div>
      <Table {...tableProps} rowKey="id" scroll={{ x: 1000 }}>
        <Table.Column dataIndex="namespace" title="Namespace" width={120} />
        <Table.Column dataIndex="key" title="Key" />
        <Table.Column dataIndex="defaultText" title="EN Text" ellipsis />
        <Table.Column
          title="Locales"
          render={(_: unknown, record: SystemMessageDto) => {
            const locales = Object.keys(record.translations ?? {});
            return locales.length
              ? locales.map((code) => <Tag key={code}>{code}</Tag>)
              : '—';
          }}
        />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_: unknown, record: SystemMessageDto) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} resource="system-messages" />
              <ShowButton hideText size="small" recordItemId={record.id} resource="system-messages" />
              <DeleteButton hideText size="small" recordItemId={record.id} resource="system-messages" />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
